export const IMPORT_JSON_MESSAGES = {
  toggleButton: 'Importar JSON',
  applyButton: 'Aplicar',
  invalidJson: 'JSON inválido.',
  notAnObject: 'El JSON debe ser un objeto.',
  wrongProduct: (received: string, expected: string) => (
    `Este JSON corresponde a otro endpoint (product: "${received}"). `
    + `Se esperaba "${expected}".`
  ),
} as const;
